export const InspectionPageRouting = {
  path: "/inspectionPage",
  name: "inspectionPage",
  meta: { title: "设置成功" },
  component: () => import(/* webpackChunkName: "join" */ "@/views/join/h5/inspection-page/index.vue"),
  children: [],
};
